import { Injectable } from '@angular/core';
import { ToastService } from '@open/ngx-components/toast';
import { Observable, throwError } from 'rxjs';
import { LayoutService } from '@components/layouts/layout.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {

  constructor(
    private toastService: ToastService,
    private layoutService: LayoutService,
  ) {
  }

  manage(error: any): Observable<never> {
    this.layoutService.stopLoading();
    const errorTitle: string = error.error?.code || error.name || error.code || 'Erreur';
    const errorMessage: string = `${error.error?.message || error.error?.messageToDisplay || error.message || error.name}`;
    this.toastService.presentToast({
      message: `${errorTitle} : ${errorMessage}`,
      borderColor: 'danger',
      pos: 'top',
    });

    return throwError(() => error);
  }
}
